import { render, staticRenderFns } from "./workShopList.vue?vue&type=template&id=01c655b7"
import script from "./workShopList.vue?vue&type=script&lang=js"
export * from "./workShopList.vue?vue&type=script&lang=js"
import style0 from "./workShopList.vue?vue&type=style&index=0&id=01c655b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports